module.exports = __webpack_public_path__ + "static/media/Illus-Nutrition_2@3x.86a24d66.png";